import { createFileRoute } from "@tanstack/react-router"
import { SpecializationCatalogDetailPage } from "@/pages/specialization-catalogs"

export const Route = createFileRoute("/specialization-catalogs_/$catalogId")({
	component: CatalogDetailRoute,
	staticData: {
		breadcrumbKey: "specializationCatalogs.detail.breadcrumb",
	},
})

function CatalogDetailRoute() {
	const { catalogId } = Route.useParams()
	return <SpecializationCatalogDetailPage catalogId={catalogId} />
}
